export default class Utils {

  deepCopy(target, source) {
    // Create a deep copy of source object.
    const copyOfDefaultModel = angular.copy(source);

    // Now it is safe to assign fields of deep copied source object to target object.
    // (if we use tsource directly instead of its copy,
    //  then source object starts sharing field references with target object since angular.extend make one level-copying
    // (simply copying reference if the field contains reference to some Object)
    //  and thus further changes applied to non primitive Object fields of actual model would affect source object as well in that case.
    // For instance, model of installation-settings form contains secureContent and serverConnectorModeSettings Objects
    angular.extend(target, copyOfDefaultModel);

    let prop;
    for (prop in target) {
      if (target.hasOwnProperty(prop) && !source.hasOwnProperty(prop)) {
        target[prop] = null;
      }
    }

    return target;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/utils/utils.js